import * as React from 'react';
import { connect } from "react-redux";
import { bindActionCreators } from "redux";

//static generic components
import ListingComponent from '../ListingComponent';
import Icon from '../../icons';
import EmptyScreen from '../../Emptyscreen';
import LetterGroup from './letterGroup';
import { generateNewGuid } from '../../containers/WorkkardDetail/utils';
import {ATTACH_WORKKARD_LETTER, CharConstants,StringConstants } from '../../containers/WorkkardDetail/constants';
import {fetchWorkkardLettersData,resetAttachedWorkkardLetters,isSelectAllLetter} from '../../containers/WorkkardDetail/actions/action';
import { DEFAULT_TAKE,DEFAULT_SKIP } from './constant';
import CheckBox from '../Checkbox';

class AttachedWorkkardLetters extends React.Component{
    constructor(props) {
        super(props);
        this.state = {
            totalSelectedFiles : [] // files attached with the workkard
        }

        this.onScrollHandler = this.onScrollHandler.bind(this);
        this.renderWorkkardFiles = this.renderWorkkardFiles.bind(this);
        this.renderEmptyScreen = this.renderEmptyScreen.bind(this);
        this.onItemClick = this.onItemClick.bind(this);
        this.onClosePopUp=this.onClosePopUp.bind(this);
        this.onAttachClick=this.onAttachClick.bind(this);
    }


    componentDidMount(){
        if(this.props.workkardId){
            const payload = {
                cId: +this.props.workkardId,
            }
            this.props.fetchWorkkardLettersData(payload);  //Action to fetch the workkard Files 
        }
    }

    componentWillUnmount(){
        this.props.resetAttachedWorkkardLetters();
    }

    //Load more files on Scroll
    onScrollHandler() {
        const { skip, take,data } = this.props.workkardLetters;
        const payload = {
            cId: +this.props.workkardId,
            skip: (skip === DEFAULT_SKIP && take > DEFAULT_TAKE ) ? take : (+skip) + (+take),
            take : (skip === DEFAULT_SKIP && take > DEFAULT_TAKE ) ? DEFAULT_TAKE : (+take),
            sortBy: 1,
            filterOption: JSON.stringify(["all"]),
        }
        if(skip+take < data.Total){
            this.props.fetchWorkkardLettersData(payload);
        }
    }
    or
    //Select and deselect the File on Click
    onItemClick(item){
        let alreadyItemsSelected = [...this.state.totalSelectedFiles];
        let newSelectedItems;
   
        if(alreadyItemsSelected.some(({guid})=>guid == item['guid'])){
            newSelectedItems = alreadyItemsSelected.filter(newItem => newItem['guid'] !== item['guid'])       //filter the item out of selected Item if item exists
        }else{
            newSelectedItems = [...alreadyItemsSelected, item]              //Add the item if it is not selected
        }

        if(this.props.workkardLetters.data.Data.length == newSelectedItems.length)
        {
            this.props.isSelectAllLetter(true);
        }
        else if(this.props.workkardLetters.data.Data.length > newSelectedItems.length)
        {
            this.props.isSelectAllLetter(false);
        }
        this.setState({
            totalSelectedFiles : newSelectedItems
        })

    }

    /**
     * Render the workkard files listing
     * @param {LetterCell} data 
     */
    renderEmptyScreen(){
        return <EmptyScreen name="EmptyLetters"/>;
    }
    renderWorkkardFiles(data){
        if (data && data.length > 0) {
            const letterIds = data.map(item=>{
                const parsedDate = `${moment(item.createdAt).format("DD/MM/YYYY")} at ${moment(item.createdAt).format("hh:mm a")}`;
                const date = parsedDate.split('at');
                return {id:item.id, date:date[0], time:date[1], data: item}
            });
            const groupLetterIds = _.groupBy(letterIds, 'date');
            const prop = {
              data:Object.keys(groupLetterIds).map(key=>({key,data:groupLetterIds[key]})),
              cellTemplate: LetterGroup,
              onScrollHandler: this.onScrollHandler,
              onItemClick: this.onItemClick,
              type:"ul",
              selectedId: '',
              classname:'poupScroll letterPopUp',
              extraData:{totalSelectedFiles:this.state.totalSelectedFiles,noteType: this.props.noteType}
            }
            return (
             <ListingComponent {...prop}/>
            );

        }
        return  "No data found"; 
    }
    onClosePopUp(){
        this.props.resetAttachedWorkkardLetters();
        this.props.hideDialogueBox();
    }

    onAttachClick(totalSeletedFiles){
        this.props.OnAttchFiles(totalSeletedFiles);
        this.props.resetAttachedWorkkardLetters();
    }
    handleSelectAll =(event)=>
    {   const selected =  event.target.checked;

        if(selected)
        {
            let newSelectedItems = [];
            
            if(this.props.workkardLetters.data){
                this.props.workkardLetters.data.Data.map((item)=>{
                    newSelectedItems = [...newSelectedItems, {
                        "guid":item.letterUrl.FileGuid,
                        "newguid":generateNewGuid(),
                        "name":item.letterUrl.FileName,
                        "size" : item.letterUrl.FileSize,
                        "filesrc" : this.props.noteType == CharConstants.Activity?StringConstants.activity:StringConstants.workkard ,
                        "caption" : item.letterUrl.Caption,
                        "url" : item.letterUrl.FileUrl
                    }];
                });
            }
            this.setState({
                totalSelectedFiles : newSelectedItems
            })
            this.props.isSelectAllLetter(true);
        }
        else{
            let newSelectedItems = [];
            this.props.isSelectAllLetter(false);
            this.setState({
                totalSelectedFiles : newSelectedItems
            })
        }
    }

    render(){
        const {data } = this.props.workkardLetters;
        return(
            <>
                <div className="modalHeader alignMiddle">
                    <div className="flexGrow">
                    <Icon name="LetterIcon" className="logsHead" />
                    <h1>{ATTACH_WORKKARD_LETTER} 
                        {(data && data.Data && data.Data.length) ? (<span>({data.Total})</span>):(<span></span>)}
                    </h1>
                    {
                        (data && data.Data && data.Data.length) ? 
                            (
                                <strong>
                                    {this.state.totalSelectedFiles.length} file(s) selected
                                </strong>
                            )
                            :
                            (
                                <strong></strong>
                            )
                    }
                        
                    </div>
                    <a  className="close" href="javascript:void(0)" onClick={()=>this.onClosePopUp()}>
                        <Icon name="close" className="icon ml" />
                    </a>
                </div>
                <div className="modalBody lttrLogModal">
                {
                    (data && data.Data && data.Data.length)
                    ?
                    (
                        <div>
                            <div className="filterBlock rowFlex">
                                <div className="filterRight alignMiddle">
                                    <div className="flexGrow">
                                        <CheckBox item={{id:"selectAllLtr",label:"Select All", checked:this.props.workkardLetters.isSelectAll}}
                                        handleCheckbox={this.handleSelectAll} />
                                    </div>
                                </div>
                            </div>
                            <div className={"notesMainContainer detailMainContainer"}>
                                { this.renderWorkkardFiles(data.Data)}
                            </div>
                        </div>
                    )
                    :
                    (
                        this.renderEmptyScreen()
                    )
                }
                </div>

                <div className="modalFooter">
                    <div className="rowFlex alignMiddle alignRight">
                        <a href="javascript:void(0)" onClick={()=> this.props.OnAttchFiles(this.state.totalSelectedFiles) } 
                        className={!this.state.totalSelectedFiles.length ? "btn disabled" : 'btn default buttonGradient'}>Attach</a>
                        <a href="javascript:void(0)" onClick={()=>{
                            this.props.hideDialogueBox()
                            this.props.resetAttachedWorkkardLetters()}
                            } className="btn link">Cancel</a>
                    </div>
                </div>
            </>

        )
    }
}


const mapStateToProps = (state) => ({
    workkardLetters: state.workkardDetail.attachedWorkkardLetters,
    workkardId: state.workkardDetail.workkardDetail.Id,
    noteType : state.workkardDetail.createNote.templateType,
});

const mapDispatchToProps = (dispatch) => ({
    fetchWorkkardLettersData:bindActionCreators(fetchWorkkardLettersData, dispatch),
    resetAttachedWorkkardLetters:bindActionCreators(resetAttachedWorkkardLetters,dispatch),
    isSelectAllLetter:bindActionCreators(isSelectAllLetter,dispatch)
});

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(AttachedWorkkardLetters);
